import React from 'react'

export const Label: React.FC = ({ children }) => {
    return (
        <p className="uppercase font-inter font-normal text-base text-orange tracking-wide dark:text-orange">
            {children}
        </p>
    )
}
